import { render } from "./Cor.vue?vue&type=template&id=616c284a&scoped=true"
import script from "./Cor.vue?vue&type=script&lang=js"
export * from "./Cor.vue?vue&type=script&lang=js"

import "./Cor.vue?vue&type=style&index=0&id=616c284a&scoped=true&lang=css"

import exportComponent from "D:\\work\\application\\棋牌游戏5.0\\chesscards_5.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-616c284a"]])

export default __exports__